import {BsGlobe, BsListNested} from "react-icons/bs";
import {Link} from "react-router-dom";
import {Tooltip, Whisper} from "rsuite";

export const TermsButton = ({ to }) => {

  const tooltip = (
    <Tooltip>
      Sub Categories
    </Tooltip>
  );

  return (
    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={tooltip}>
      <Link to={to} className="btn btn-info">
        <BsListNested />
      </Link>
    </Whisper>
  )
}